module.exports = __webpack_public_path__ + "static/media/beep.972c97d9.mp3";